<template>
  <div class="electronic-rent-money">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-confirm value="手动充值" @confirm="dialogVisible = true" v-if="permissionCodes.indexOf('013005001') !== -1" />
        <!--<button-add :pathName="addCustom"/>-->
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('013005004') !== -1"
          value="导出"/>
      </div>
      <div style="display: flex;justify-content: space-between;line-height: 32px;">
        <div style="margin-right: 5px;flex: 1;">余额不足</div>
        <el-input
          placeholder="请输入金额"
          size="small"
          v-model="requestData.rentBalance"
          style="width: 180px;"
          v-on:blur="changeRentBalance()"
          @keyup.enter.native="search()">
          <template slot="append">元</template>
        </el-input>
      </div>
      <input-search placeholder="住户名称/房间号" @search="searchKey" />
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" @lookOver="lookOver" @deleteLine="deleteLine" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @settlementRow="settlementRow" :operationArr="operationArr"  />

    <el-dialog
      :visible.sync="dialogVisible"
      title="充值"
      width="600px">
      <el-form style="width: 420px;margin: 0 auto;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间：</span>
          </div>
<!--          <el-select
            v-model="roomCode"
            filterable
            remote
            reserve-keyword
            placeholder="请输入房号或企业关键词"
            :loading="enterpriseLoading"
            size="small" style="width: 280px"
            :remote-method="enterpriseRemoteMethod">
            <el-option
              v-for="item in enterpriseList"
              :key="item.code"
              :label="item._label"
              :value="item.code">
            </el-option>
          </el-select>-->
          <input-tree :fetch="fetchDetail" :showCheckBox="false" @chooseLine="getRoomList" :theValue="roomCode" :theName="buildingRoomName" style="width: 280px" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">充值人姓名：</span>
          </div>
          <el-input v-model="personName" size="small" style="width: 280px;" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">充值人手机：</span>
          </div>
          <el-input v-model="personPhone" size="small" style="width: 280px;" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">充值金额：</span>
          </div>
          <el-input v-model="money" size="small" style="width: 280px;" type="number" v-on:blur="changeMoney()">
            <template slot="append">元</template>
          </el-input>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="recharge" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="dialogRoomVisible"
      title="结算"
      width="600px">
      <el-form style="width: 420px;margin: 0 auto;">
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">房间：</span>
          </div>
          <el-input disabled v-model="this.settlementData.roomNumber" size="small" style="width: 280px;" />
        </div>
        <div class="form-line">
          <div class="textBox">
            <b class="red">*</b>
            <span class="line-text">结算金额：</span>
          </div>
          <el-input v-model="settlementMoney" size="small" style="width: 280px;" type="number" v-on:blur="changeMoney()">
            <template slot="append">元</template>
          </el-input>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogRoomVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="settlementConfirm" size="small">确 定</el-button>
      </div>
    </el-dialog>


    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">
            <div style="text-align: left;margin: 10px 0 20px 0;">
              <el-date-picker v-model="electricityTimeArr" size="small" type="datetimerange"
                              :picker-options="pickerOptions2" range-separator="至"
                              start-placeholder="开始日期" end-placeholder="结束日期"
                              align="right" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </div>
<!--            <table-main :selection="false" :hasOperation="false" :tableHead="electricityTableHead" :tableData="electricityTableData" :total="electricityTotal" :pageNum="electricityPageNum" :pageSize="electricityPageSize" @changePagination="changeElectricityPagination"/>-->
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputTree from '../../../components/common/inputs/input-tree'
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Finance";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import { nError, nSuccess } from "../../../utils/notice";
import { pattern } from "../../../utils/regular";
import {treeApi} from '../../api/ElectronicTreeApi'

export default {
  components: {
    ButtonConfirm,
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb,
    InputTree
  },
  name: "electronic-finance-rent-record",
  data() {
    return {
      permissionCodes: "",
      breadcrumb: [
        {
          value: "智慧财务",
          name: "finance-over-view",
        },
        {
          value: "余额管理",
        },
      ],
      // addCustom: 'amount-add',
      exportUrl: "",
      payStatusList: [
        {
          key: "",
          label: "全部",
        },
        {
          key: "0",
          label: "未缴费",
        },
        {
          key: "1",
          label: "已缴费",
        },
      ],
      tableHead: [

        {
          prop: "roomNumber",
          label: "房间号",
        },
        {
          prop: "enterpriseName",
          label: "承租主体",
        },
        {
          prop: "rentBalance",
          label: "账户余额(元)",
        },
      ],
      // {
      //   isLooking: true,
      //     label: '余额明细'
      // },
      operationArr: ["settlement"],
      // operationArr: ['delete'],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        rentBalance: "",
      },
      dialogVisible: false,
      enterpriseLoading: false,

      fetchDetail: null,
      buildingName: '',
      buildingCode: '',
      buildingRoomName: '',

      enterpriseList: [],

      rentCode: "",
      rentName: "",

      roomCode: "",
      roomName: "",
      personName: "",
      personPhone: "",
      money: "",

      dialogRoomVisible: false,
      settlementDataVisible: false,
      settlementData: {},
      settlementMoney: '',

      accountCode: "",
      accountName: "",

      windowLeftBox: false,
      pickerOptions2: {
        disabledDate(time) {
          return time.getTime() > new Date((new Date() / 1000 + 86400) * 1000);
        },
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      electricityTableHead: [
        {
          prop: "electricMeterName",
          label: "电表名称",
        },
        {
          prop: "relateRoom",
          label: "电表所在房间",
        },
        {
          prop: "vally",
          label: "谷电量",
        },
        {
          prop: "ordinary",
          label: "平电量",
        },
        {
          prop: "sharp",
          label: "尖电量",
        },
        {
          prop: "electricity",
          label: "电表读数",
        },
        {
          prop: "transactionTime",
          label: "扣款时间",
        },
      ],
      electricityTableData: [],
      electricDeviceCode: "",
      electricityTotal: 0,
      electricityPageSize: 10,
      electricityPageNum: 1,
      electricityTimeArr: [],
    };
  },
  created() {
    this.accountName = bus.global.accountName;
    this.accountCode = bus.global.accountCode;
    this.permissionCodes = bus.global.permissionCodes;
    this.getPage();
    this.fetchDetail = () => {
      let treeList = []
      let yqCode = ''

      return treeApi.getYqInfo()
        .then(yqData => {
          let yqObj = {}
          yqCode = yqData.yqCode
          yqObj._value = yqData.yqCode
          yqObj._label = yqData.yqName
          yqObj.parentCode = '0'
          yqObj.level = 1
          yqObj.code = yqData.yqCode
          treeList.push(yqObj)

          treeApi.getVacancyRoomInfo(this.currentCode)
            .then(roomList => {
              roomList.map(room => {
                let roomObj = {}
                roomObj.buildingName = room.buildingName
                roomObj.buildingCode = room.buildingCode
                roomObj._value = room.code
                roomObj._label = room.roomNumber
                roomObj.parentCode = room.floorCode
                roomObj.level = 4
                roomObj.code = room.code
                roomObj.roomArea = room.roomArea
                roomObj.roomRent = room.roomRent
                roomObj.roomType = room.roomType
                treeList.push(roomObj)
              })
            })

          treeApi.getBuildingList()
            .then(buildingList => {
              buildingList.map(v => {
                let obj = {}
                obj._value = v.code
                obj._label = v.name
                obj.parentCode = yqCode
                obj.level = 2
                obj.code = v.code
                treeList.push(obj)
                if (v.floors.length > 0) {
                  v.floors.map(floor => {
                    let floorObj = {}
                    floorObj._value = floor.code
                    floorObj._label = floor.name
                    floorObj.parentCode = floor.buildingCode
                    floorObj.level = 3
                    floorObj.code = floor.code
                    treeList.push(floorObj)
                  })
                }
              })

            })
          return treeList
        })
    }
  },
  activated() {
    this.getPage()
  },
  methods: {
    // 关键词搜索
    enterpriseRemoteMethod(query) {
      this.enterpriseLoading = true;
      this.$axios
        .post(api.getEnterpriseList, {
          searchKey: query,
          isIncludeYq: "NO",
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            this.enterpriseLoading = false;
            let data = res.data.data;
            data.map((v) => {
              if (v.roomInfoNumber) {
                v._label = `${v.enterpriseName}/${v.roomInfoNumber}`;
              } else {
                v._label = `${v.enterpriseName}`;
              }
            });
            this.enterpriseList = data;
          }
        })
        .catch(errorHandler("获取住户列表失败"));
    },
    beforeDownload() {
      this.exportUrl = `${api.exportElectricRoomMoney}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&rentBalance=${this.requestData.rentBalance}`;
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios
        .post(api.getElectricRoomMoneyPage, reqData)
        .then((res) => {
          let data = res.data.data.list;
          data.map((v) => {
            v.code = v.rentCode;
          });
          this.total = res.data.data.total;
          this.tableData = data;
        })
        .catch(errorHandler("获取金额信息失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search() {
      this.pageNum = 1;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    settlementRow(data) {
      for (let i in data) {
        if (data[i] === "--") {
          data[i] = "";
        }
      }
      this.settlementData = data;
      // this.settlementConfirm();
      this.dialogRoomVisible= true
    },
    // 结算
    settlementConfirm() {
      if (!this.settlementMoney){
        nSuccess("请输入结算金额");
        return false;
      }
      this.settlementData.money = +this.settlementMoney
      this.$confirm(
        `是否确定为${this.settlementData.roomNumber}结算账户余额？`,
        "温馨提示"
      )
        .then(() => {
          this.$axios
            .post(api.roomSettlement, this.settlementData)
            .then((res) => {
              if (res.data.retCode === 1) {
                nSuccess("结算成功");
                this.dialogRoomVisible= false
                this.getPage();
              }
            })
            .catch(errorHandler("结算失败"));
        })
        .catch(() => {
          console.log("取消结算");
        });
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },
    changeMoney() {
      if (this.money && +this.money > 0) {
        this.money = parseFloat(this.money).toFixed(2).toString();
      } else {
        this.money = "1.00";
      }
    },

    changeRentBalance() {
      if (this.requestData.rentBalance) {
        this.requestData.rentBalance = parseFloat(this.requestData.rentBalance)
          .toFixed(2)
          .toString();
      } else {
        this.requestData.rentBalance = "";
      }
      this.search();
    },

    getRoomList (data) {
      if (data) {
        this.roomCode = data._value
        this.roomName = data._label
        this.buildingName = data.buildingName
        this.buildingCode = data.buildingCode
        this.buildingRoomName = `${data.buildingName}${data._label}`
      } else {
        this.roomCode = ''
        this.roomName = ''
        this.buildingName = ''
        this.buildingCode = ''
        this.buildingRoomName = ''
      }
    },

    // 充值
    recharge() {
      let checkPhone = pattern.telephoneOrPhone.test(this.personPhone);
      if (!this.roomCode) {
        nError("请选择房间");
        return false;
      }
      if (!this.personName) {
        nError("请输入充值人姓名");
        return false;
      }
      if (!this.personPhone) {
        nError("请输入充值人手机");
        return false;
      } else {
        if (!checkPhone) {
          nError("手机格式不正确");
          return false;
        }
      }
      if (!this.money) {
        nError("请输入充值金额");
        return false;
      }
      this.enterpriseList.map((v) => {
        if (v.code === this.rentCode) {
          this.rentName = v.enterpriseName;
        }
      });
      this.$confirm(
        `是否确定为${this.rentName}充值${this.money}元？`,
        "温馨提示"
      )
        .then(() => {
          this.$axios
            .post(api.roomRecharge, {
              roomCode: this.roomCode,
              roomNumber: this.roomName,
              personName: this.personName,
              personPhone: this.personPhone,
              money: this.money,
              accountCode: this.accountCode,
              accountName: this.accountName,
            })
            .then((res) => {
              if (res.data.retCode === 1) {
                nSuccess("操作成功");
                this.dialogVisible = false;
                this.roomCode = "";
                this.roomName = "";
                this.personName = "";
                this.personPhone = "";
                this.money = "";
              }
              this.getPage();
            })
            .catch(errorHandler("操作失败"));
        })
        .catch(() => {
          console.log("取消操作");
        });
    },

    // 删除
    deleteLine(code) {
      this.$axios
        .post(api.deleteElectricRentMoney, code)
        .then((res) => {
          nSuccess("删除成功");
          this.getPage();
        })
        .catch(errorHandler("删除失败"));
    },

    // 查询电表电量
    lookOver(row) {
      this.electricDeviceCode = row.code;
      this.getElectricityPage();
    },
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.enterpriseRemoteMethod();
      } else {
        this.rentCode = "";
        this.rentName = "";
        this.personName = "";
        this.personPhone = "";
        this.money = "";
      }
    },
  },
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
.form-line {
  margin: 5px 0 20px 0;
  display: flex;
  justify-content: flex-start;
}
.line-text {
  color: #48576a;
  font-size: 14px;
}
.textBox {
  display: inline-block;
  width: 130px;
  line-height: 32px;
  text-align: right;
}
.red {
  color: #ff0000;
}
</style>

<style lang="less">
.electronic-rent-money {
  .el-input__inner {
    padding: 0 0 0 15px;
  }
  .el-input--mini {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .el-dialog__header {
    text-align: left;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Finance/ElectronicFinance/ElectronicFinanceRentMoney.vue